document.addEventListener('page:loaded', () => {
  if (theme.config.motionReduced || Shopify.designMode) return;

  // Anything on screen at load stays put.
  const reveal = (element) => {
    if (element.getBoundingClientRect().top < window.innerHeight) return;

    const animation = new theme.Animation(element);
    animation.beforeLoad();
    Motion.inView(element, () => animation.load(), animation.viewOptions);
  };

  // Sections with the theme's own reveal elements already animate.
  if (theme.animation?.revealSections) {
    document.querySelectorAll('#MainContent .shopify-section > .section').forEach((section) => {
      if (!section.querySelector('animate-element, split-words')) reveal(section);
    });
  }

  // Large section images settle in from zoomed
  document.querySelectorAll('#MainContent picture.media:not(.media--transparent) > img').forEach((image) => {
    if (image.closest('a, button, .product, .product-card, [data-animate="zoom-out"]') || image.parentElement.offsetHeight < 240) return;

    image.setAttribute('data-animate', 'zoom-out');
    reveal(image);
  });
});
